import { DEFAULT_LOCALE, SUPPORTED_LOCALES, type Locale } from '../site'

const STORAGE_KEY = 'sd.locale'
const FOLLOW_KEY = 'sd.localeFollowSystem'

export function isLocale(value: string): value is Locale {
  return (SUPPORTED_LOCALES as readonly string[]).includes(value)
}

export function resolveDefaultLocale(): Locale {
  const params = new URLSearchParams(location.search)
  const fromUrl = params.get('lang')
  const followSystem = localStorage.getItem(FOLLOW_KEY) === '1'
  const saved = localStorage.getItem(STORAGE_KEY)

  if (!followSystem && saved && isLocale(saved)) return saved
  if (fromUrl && isLocale(fromUrl)) return fromUrl

  const candidates = navigator.languages?.length
    ? [...navigator.languages]
    : [navigator.language]

  for (const tag of candidates) {
    const lower = (tag || '').toLowerCase()
    const exact = SUPPORTED_LOCALES.find((item) => item.toLowerCase() === lower)
    if (exact) return exact

    const primary = lower.split('-')[0]
    if (primary === 'zh') {
      if (/zh-(tw|hk|mo)/.test(lower)) return 'zh-TW'
      return 'zh-CN'
    }

    const byPrimary = SUPPORTED_LOCALES.find(
      (item) =>
        item.toLowerCase() === primary ||
        item.toLowerCase().startsWith(`${primary}-`),
    )
    if (byPrimary) return byPrimary
  }

  return DEFAULT_LOCALE
}

export function getFollowSystem(): boolean {
  return localStorage.getItem(FOLLOW_KEY) === '1'
}

export function setFollowSystem(follow: boolean): void {
  localStorage.setItem(FOLLOW_KEY, follow ? '1' : '0')
  if (follow) localStorage.removeItem(STORAGE_KEY)
}

export function setLocale(locale: Locale): void {
  localStorage.setItem(STORAGE_KEY, locale)
  localStorage.setItem(FOLLOW_KEY, '0')
}

export function applyDocumentLocale(locale: Locale): void {
  document.documentElement.lang = locale
}
